(function () {
    'use strict';

    angular.module("imApp").factory("poFinishProdListService", ['$ihttp', function ($ihttp) {
        let service = {
            listFinishedProducts: function (parms) {
                return $ihttp.post({
                    method: 181,
                    parameters: parms || {}
                });
            },
            scanItem: function (setting) {
                return $ihttp.post({
                    method: 188,
                    parameters: setting
                });
            },
            abortPoFinish: function (parms) {
                return $ihttp.post({
                    method: 212,
                    parameters: parms
                });
            }
        };

        return service;
    }]);
})();
